/**
 * @author Harshitha.k
 * @description 
 */

import { Tree, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
const { TreeNode } = Tree;

const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [deviceList, setDeviceList] = useState(props.deviceList || []);


  useEffect(() => {
    setTreeData(props.treeData || []);
    setDeviceList(deviceList);
  }, [props.selectedKeys, props.treeData]);

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={`${setTranslation(item.DisplayCode)}${item.Name ? `-${setTranslation(item.Name)}` : ''
                }`}
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={
              <div
                style={{ fontWeight: item.Type === 'Device' ? 'bold' : 'none' }}
                onClick={() => getData(item.Name, item)}
              >
                {`${setTranslation(item.DisplayCode)}${item.Code ? `-${setTranslation(item.Name)}` : ''
                  }`}
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };

  const setTranslation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const getData = (selectedKey, key) => {
    onSelect([selectedKey], key);
  };

  const onSelect = (selectedKeys, itemData) => {
    let { Code } = itemData;
    let deviceObject = deviceList.filter((device) => {
      return device.Name === selectedKeys[0];
    });

    if (deviceObject && deviceObject.length > 0) {
      props.handleDropdownChange(selectedKeys[0], "EquipmentCode",Code);
    } else {
      message.error('Please select valid equipment');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250,
      }}
    >
      <Tree
        showLine
        defaultExpandAll={true}
        switcherIcon={<DownOutlined />}
      >
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};

export default HierarchyModal;
